import { Outlet, useNavigate, useLocation } from "react-router";
import { useProfilStore } from "../stores/useStore";
import { observer } from "mobx-react-lite";
import Header from "../components/general/Header";
import AnimatedBackground from "../components/general/AnimatedBackground";
import ProfilPictureList from "../components/compte/ProfilPictureList";
import ThemeList from "../components/compte/ThemeList";
import "../style/Profil.css";
import { useState } from "react";
import Popup from "../components/general/Popup"

const Profil = observer(() => {
  const profilStore = useProfilStore();
  const navigate = useNavigate();
  const location = useLocation();
  const isEditMode = location.pathname.endsWith("/edit");
  const [changeThemeIsOpen, setChangeThemeIsOpen] = useState(false);
  const [changeProfilPictureIsOpen, setChangeProfilPictureIsOpen] = useState(false);

  if (!profilStore.isConnected) {
    navigate("/login");
    return null;
  }



  const handleDisconnect = () => {
    profilStore.disconnect();
  };

  const handleOpenEditMode = () => {
    navigate("/profil/edit");
  };

  const handleProfilPictureChoice = (src) => {
    profilStore.updateProfilPicture(src);
    setChangeProfilPictureIsOpen(false);
  };

  const handleThemeChoice = (theme) => {
    profilStore.updateTheme(theme);
    setChangeThemeIsOpen(false);
  };

  return (
    <main className={`profil_main ${profilStore.profilPicture ? "hasProfilPicture" : ""}`}>
      <Header admin={profilStore.admin} connected={profilStore.isConnected} imageProfil={profilStore.isConnected&&profilStore.profilPicture?profilStore.profilPicture:undefined}/>
      <AnimatedBackground className="profil_animatedCanva" color={profilStore.theme.color ? profilStore.theme.color : null} />
      {profilStore.profilPicture && (
        <img title="Photo de profil" src={profilStore.profilPicture} alt="Profil" className="profil_profilPicture" />
      )}
      <div className="profil_editVisualDiv">
        <button className="profil_changeThemeButton" onClick={() => setChangeThemeIsOpen(true)}>Changer le thème</button>
        <button className="profil_changeProfilPictureButton" onClick={() => setChangeProfilPictureIsOpen(true)}>
          {profilStore.profilPicture ? "Changer la photo de profil" : "Ajouter une photo de profil"}
        </button>
      </div>
      <div className="profil_mainContent">
        <h2 title="Score" className="profil_score">{profilStore.score}</h2>
        <h1 title="Pseudo" className="profil_pseudo">{profilStore.pseudo}</h1>
        <h2 title="Mail" className="profil_mail">{profilStore.mail}</h2>
        <Outlet/>
        {isEditMode?null:<div className="profil_editProfilDiv">
          <button className="profil_deconnectButton" onClick={handleDisconnect}>Déconnecter</button>
          <button className="profil_editButton" onClick={handleOpenEditMode}>Éditer le profil</button>
        </div>}
      </div>




      {/* ▓▓▓▓▓▓▓▓▓▓▓▓ MODAL ▓▓▓▓▓▓▓▓▓▓▓▓ */}
      <Popup popupTitle="Choisir un thème" bodyOpenClassName="theme-change" isOpen={changeThemeIsOpen} closeModal={() => setChangeThemeIsOpen(false)}>
        <ThemeList onClick={handleThemeChoice} selectedTheme={profilStore.theme.name} />
      </Popup>
      <Popup popupTitle="Choisir une photo de profil" bodyOpenClassName="profilPicture-change" isOpen={changeProfilPictureIsOpen} closeModal={() => setChangeProfilPictureIsOpen(false)}>
        <ProfilPictureList onClick={handleProfilPictureChoice} selectedPicture={profilStore.profilPicture} />
      </Popup>
    </main>
  );
});

export default Profil;
